// handleMarkerClickCotton.js
// End Handle Popup Call

export const handleMarkerClickCotton = (selected, selectedPlot,openMandtPopup) => {
        console.log("aaaaaaaaaaaaaaaaaaaaaaaa", selected);
        console.log("aaaaaaaaaaaaaaaaaaaaaaselectedPlotaa", selectedPlot);
        //alert(selected[0].value)
   
   if (selected[0].value === "28") {
    
    function getDetailValue(description, key) {
        if (key.includes("Month and Year")) {
            const regex = new RegExp(`${key} - (\\d{2}/\\d{4})`); // Capture MM/YYYY format
            const match = description.match(regex);
            return match ? match[1].trim() : "N/A";
        } else {
            const regex = new RegExp(`${key} - ([^A-Z]+)`, "i"); // Extracts value until next uppercase letter (key separator)
            const match = description.match(regex);
            return match ? match[1].split("/")[0].trim() : "N/A"; // Handle cases with extra '/'
        }
    }

    function getFarmerName(value) {
        const match = value.match(/Farmer ID\/Name - (\d+) \/ (.+)/);
        return match ? `${match[2]} (${match[1]})` : value;
    }

    // Extract State Name Properly
    function getStateValue(description) {
        const match = description.match(/State Name\/Code - ([^\/\n]+)/);
        return match ? match[1].trim() : "N/A";
    }

    // Extract District, Block, and Village Correctly
    function extractLocation(description, key) {
        const regex = new RegExp(`${key}\\s*-\\s*([^/\\n]+)`, "i");
        const match = description.match(regex);
        return match ? match[1].trim() : "N/A";
    }

    const tableRows = [
        { label: "Scheme", value: 'NMEO-OP' },
        { label: "Company Name", value: 'Patanjali' },
        { label: "Farmer ID/Name", value: getFarmerName(selectedPlot?.name || "N/A") },
        { label: "State", value: getStateValue(selectedPlot.description) || "N/A" },
        { label: "District", value: extractLocation(selectedPlot.description, "District Name/Code") || "N/A" },
        { label: "Tehsil/Block", value: extractLocation(selectedPlot.description, "Tehsil /Block Name/Code") || "N/A" },
        { label: "Village", value: extractLocation(selectedPlot.description, "Village") || "N/A" },
        { label: "Total Area of the Plot", value: getDetailValue(selectedPlot.description, "Total Area of the Plot") || "N/A" },
        { label: "Total Area of the Plot under Oil Palm Cultivation", value: getDetailValue(selectedPlot.description, "Total Area of the Plot under Oil Palm Cultivation") || "N/A" },
        { label: "Land Registration ID /Survey Number", value: getDetailValue(selectedPlot.description, "Land Registration ID /Survey Number") || "N/A" },
        { label: "Ownership holding", value: getDetailValue(selectedPlot.description, "Ownership holding (Land holding)") || "N/A" },
        { label: "Geo tagging reference details", value: getDetailValue(selectedPlot.description, "Geo tagging reference details") || "N/A" },
        { label: "Number of Plants in the Plot", value: getDetailValue(selectedPlot.description, "Number of Plants in the Plot") || "N/A" },
        { label: "Month and Year of Sowing/Plantation", value: getDetailValue(selectedPlot.description, "Month and Year of Sowing/Plantation") || "N/A" },
        { label: "Month and Year to Start of FFB Production", value: getDetailValue(selectedPlot.description, "Month and Year to Start of FFB Production") || "N/A" },
        { label: "Name of the FFBs Procurement Agency", value: getDetailValue(selectedPlot.description, "Name of the FFBs Procurement Agency") || "N/A" }
    ];

    const rowsHtml = tableRows
        .filter(row => row.value && row.value !== "N/A") // Remove empty rows
        .map(row => `<tr><th>${row.label} :</th><td>${row.value}</td></tr>`)
        .join("");

    // Content without image
    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}</table>
        </div>`;

    // Debugging output
    console.log("Generated HTML:", contentStringCotton);

    // Ensure the element exists before modifying
    const infoContainer = document.getElementById("infoDetailsCotton");
    if (infoContainer) {
        infoContainer.style.display = "block";
        infoContainer.innerHTML = contentStringCotton;
    } else {
        console.error("Error: Element with id 'infoDetailsCotton' not found!");
    }
}




    if (selectedPlot.gisSchemeCode ===25) {
        const tableRows = [
            { label: "Scheme Name", value: "NMEO-OP"},
            { label: "Company Name", value: selectedPlot.ffBsProcurementAgency },
            { label: "Farmer Id", value: selectedPlot.farmer_unique_id },
            { label: "State", value: selectedPlot.farmer_State_Name },
            { label: "District", value: selectedPlot.farmer_District_Name },
            { label: "Sub District", value: selectedPlot.plot_Block_Name },
            { label: "Village", value: selectedPlot.plot_Village_Name },
            { label: "Farmer Name", value: selectedPlot.farmer_Name },
            { label: "Gender", value: selectedPlot.gender },
            { label: "Category", value: selectedPlot.category },
            { label: "Mobile", value: selectedPlot.mobile_No },
            { label: "Address", value: selectedPlot.address },
            { label: "Ownership Holding", value: selectedPlot.ownership_Holding },
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot.photo || "https://krishimapper.dac.gov.in/imagenotfound.png";
        const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>`;

        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;

        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    } 
    if (selectedPlot.gisSchemeCode ===24) {

        const tableRows = [
            { label: "Scheme Name", value:"NMEO-OP" },
            { label: "Company Name", value:selectedPlot.gisSchemeName },
            { label: "Company Name", value: selectedPlot.ffBsProcurementAgency },
            { label: "Farmer Name", value: selectedPlot.farmerName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Sub District", value: selectedPlot.subDistrictName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Farmer Name", value: selectedPlot.farmer_Name },
          
           
            { label: "Mobile", value: selectedPlot.mobile_No },
            { label: "Address", value: selectedPlot.address },
            { label: "Ownership Holding", value: selectedPlot.ownership_Holding },
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot.farmerImage || "https://krishimapper.dac.gov.in/imagenotfound.png";
        const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModaltest" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>`;

        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    } 
    if (selected[0].value === '44') {
        const tableRows = [
            { label: "Scheme Name", value: "RKVY" },
            { label: "District", value: selectedPlot[0].distName },
            { label: "State", value: selectedPlot[0].statename },
            { label: "Village", value: selectedPlot[0].village },
            { label: "Sector", value: selectedPlot[0].sector },
            { label: "Status", value: selectedPlot[0].projectstatus },
            { label: "Start Year", value: selectedPlot[0].projectstartingyear },
            { label: "End Year", value: selectedPlot[0].yearcompletion },
            { label: "Benificiry Name", value: selectedPlot[0].benf_name },
            { label: "Observer name", value: selectedPlot[0].observername },
            { label: "Mandal", value: selectedPlot[0].mandal },
            { label: "Project status", value: selectedPlot[0].projectstatus },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot[0].photo1 || "https://krishimapper.dac.gov.in/imagenotfound.png";
       // const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="" class="d-block w-100" alt="..."/>
            </div>`;

        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode === 1){
    const tableRows = [
        { label: "Scheme Name", value: selectedPlot.gisSchemeName },
         { label: "Survey  Date", value: "-"
            },

        { label: "State", value: selectedPlot.stateName },
        { label: "District", value: selectedPlot.districtName },
        { label: "Sub District", value: selectedPlot.plot_Block_Name },
        { label: "Village", value: selectedPlot.plot_Village_Name },
        { label: "Farmer Name", value: selectedPlot.appName },
        { label: "Address", value: selectedPlot.address },
        { label: "Ownership Holding", value: selectedPlot.ownership_Holding },
        { label: "Department Name", value: selectedPlot.departmentName },
        { label: "Institute Name", value: selectedPlot.instituteNM },
       
        { 
        label: "Total Area", 
        value: selectedPlot.totalPolygonArea 
            ? parseFloat(selectedPlot.totalPolygonArea).toFixed(2) 
            : "0.00" 
        },
    ];

    const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract images from `photo` field (comma-separated list)
    const imageUrls = selectedPlot.photo
        ? selectedPlot.photo.split(",").map(url => `https://acabcmis.gov.in/acabcwebapi/${url.trim()}`)
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate Carousel Items for Modal
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    // Set the images inside the Bootstrap Carousel
    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }

    if (selectedPlot.gisSchemeCode === 2) {
    const tableRows = [
        { label: "Scheme Name", value: selectedPlot.gisSchemeName },
        { label: "Survey No ", value: selectedPlot.surveyNo },
        { label: "Survey Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
         { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
        { label: "State", value: selectedPlot.stateName },
        { label: "District", value: selectedPlot.districtName },
        { label: "Sub District", value: selectedPlot.subDistrictName },
        { label: "Village", value: selectedPlot.villageName },
        { label: "Block", value: selectedPlot.blockName },
        { label: "Beneficiary Name", value: selectedPlot.beneficiaryName },
        { label: "Beneficiary Address", value: selectedPlot.benfAddress },
        { label: "Project Name", value: selectedPlot.projectName },
       
        { label: "Crop Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].cropName },
        { label: "Crop Category Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].cropCategoryName },
        { label: "Surveyor Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
    ];

    const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
}

    if (selectedPlot.gisSchemeCode ===3) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.project_Geo_Update_Date 
                ? new Date(selectedPlot.project_Geo_Update_Date).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Beneficiary Type", value: selectedPlot.beneficiaryType },
            { label: "Beneficiary Id", value: selectedPlot.beneficiaryID },
            { label: "Beneficiary Address", value: selectedPlot.benfAddress },
            { label: "Project Type", value: selectedPlot.project_Type },
            { label: "Project Name", value: selectedPlot.projectName },
            { label: "Project Cost", value: selectedPlot.project_Cost },
            { label: "Approved Loan amount ", value: selectedPlot.approved_Loan_Amount_AIF },
            { label: "Approved Loan Term Year", value: selectedPlot.approved_Loan_Term_Year },
            
            { label: "Loan Status", value: selectedPlot.loan_Application_Status_Name },

           
        ];
         const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    
    const imageUrls = selectedPlot.geoImages.length > 0
        ? selectedPlot.geoImages.map(img => 
            `${img.aiF_Image_Name}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

   
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode ===4) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.project_Geo_Update_Date 
                ? new Date(selectedPlot.project_Geo_Update_Date).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Project  Name", value: selectedPlot.projectName },
            { label: "Project  Type", value: selectedPlot.project_Type },
            { label: "Project  Cost", value: selectedPlot.project_Cost },
            { label: "Loan Application  No", value: selectedPlot.loanApplicationNo },
            { label: "Beneficiary Address", value: selectedPlot.benfAddress },
              { label: "Loan Status", value: selectedPlot.loan_Application_Status_Name },
             
           
        ];

       const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    
    const imageUrls = selectedPlot.geoImages.length > 0
        ? selectedPlot.geoImages.map(img => 
            `${img.aiF_Image_Name}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

   
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode ===5) {
        const tableRows = [ 
           { label: "Scheme Name", value: 'M&T-CHC' },
             { label: "Survey  Date", value: selectedPlot.registraionDate 
                ? new Date(selectedPlot.registraionDate).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "sub-District", value: selectedPlot.subDistrictName },
            { label: "Village", value: selectedPlot.revenueVillageName },
            { label: "Block Name", value: selectedPlot.blockName },
            { label: "Group Name", value: selectedPlot.groupName },
            { label: "Shg Name", value: selectedPlot.shgName },
             { label: "Survey  Date", value: selectedPlot.addedDate 
                ? new Date(selectedPlot.addedDate).toLocaleDateString("en-CA") 
                : "" 
            },
            
           
        ];

         const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot.chcCenterPhotoPath || "https://krishimapper.dac.gov.in/imagenotfound.png";
        const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>`;

        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;

        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
     if (selectedPlot.gisSchemeCode === 15) {
        const tableRows = [ 
            { label: "Scheme Name", value: "M&T-CHC" },
            { label: "Survey Date", value: selectedPlot.registraionDate 
                ? new Date(selectedPlot.registraionDate).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Sub-District", value: selectedPlot.subDistrictName },
            { label: "Village", value: selectedPlot.revenueVillageName },
            { label: "Group Name", value: selectedPlot.groupName },
            { label: "Source Registration", value: selectedPlot.sourceofRegistration },
        ];

        let rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        // Add clickable "No of Implement" if available
        if (selectedPlot.no_ImplementSubsidyID) {
            rowsHtml += `
                <tr>
                    <th>No of Implement :</th>
                    <td id="openMandt" data-bs-toggle="modal" data-bs-target="#exampleModalMandT" 
                        style="cursor: pointer; color: blue; text-decoration: underline;">
                         ${selectedPlot.no_ImplementSubsidyID}
                    </td>
                </tr>
            `;
        }

        // Handle image with fallback
        const imageUrl = selectedPlot.chcCenterPhotoPath
            ? `https://agrimachinery.nic.in/ChcApp${selectedPlot.chcCenterPhotoPath}`
            : "https://krishimapper.dac.gov.in/imagenotfound.png";

        const imageRow = `
            <tr>
                <th>Image :</th>
                <td>
                    <img alt="image" src="${imageUrl}" height="150px" width="150px" 
                         data-bs-toggle="modal" data-bs-target="#exampleModal">
                </td>
            </tr>
        `;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>
        `;

        // Generate image for the carousel
        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>
        `;

        // Update the DOM
        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

        // Use a longer delay (300ms) to ensure the element is in the DOM
        setTimeout(() => {
            const openMandtElement = document.getElementById("openMandt");
            if (openMandtElement) {
                openMandtElement.addEventListener("click", () => openMandtPopup(selectedPlot.loginID));
            }
        }, 300);
    }

     if (selectedPlot.gisSchemeCode ===6) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey No ", value: selectedPlot.farmerCropSurveyPolygonList[0].surveyNo },
            { label: "Survey No", value: selectedPlot.surveyNo },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
          
            { label: "Survey Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Sub District", value: selectedPlot.subDistrictName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Beneficiary Name", value: selectedPlot.beneficiaryName },
            { label: "Beneficiary Address", value: selectedPlot.benfAddress },
            { label: "Project Name", value: selectedPlot.projectName },
           
        ];
         const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

   
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode === 7) {
    const tableRows = [
        { label: "Scheme Name", value: selectedPlot.gisSchemeName },
        { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
        { label: "State", value: selectedPlot.stateName },
        { label: "District", value: selectedPlot.districtName },
        { label: "Village", value: selectedPlot.villageName },

        
        

        { label: "Beneficiary Name", value: selectedPlot.beneficiaryName },
        { label: "Crop Group Name", value: selectedPlot.cropGroupName },
        { label: "Crop Name", value: selectedPlot.cropName },
      
        { label: "Sowing Date", value: selectedPlot.sowingDate 
                ? new Date(selectedPlot.sowingDate).toLocaleDateString("en-CA") 
                : "" 
            },
        { label: "Season Name", value: selectedPlot.seasonName },
        { label: "Area Under Demonstration ", value: selectedPlot.areaUnderDemonstration },
        { label: "Demonstration Yield", value: selectedPlot.demonstrationYield },
        { label: "Avg Yield of Village ", value: selectedPlot.avgYieldofVillage },
      
    ];

    const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Handling single or multiple images in `landPhoto`
    let imageUrls = [];
    if (selectedPlot.landPhoto) {
        // Check if it contains a comma (indicating multiple images)
        if (selectedPlot.landPhoto.includes(",")) {
            imageUrls = selectedPlot.landPhoto.split(",").map(url => `https://nfsm.gov.in/nfsmapi1/${url.trim()}`);
        } else {
            imageUrls = [`https://nfsm.gov.in/nfsmapi1/${selectedPlot.landPhoto.trim()}`];
        }
    } else {
        imageUrls = ["https://krishimapper.dac.gov.in/imagenotfound.png"];
    }

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails" style="height: auto; max-height: 500px; overflow-y: auto;">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate Carousel Items for Modal
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}" style="height: 400px;">
            <img src="${img}" class="d-block w-100" style="height: 100%; object-fit: contain;" alt="...">
        </div>`).join("");

    // Set the images inside the Bootstrap Carousel
    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }

    if (selectedPlot.gisSchemeCode === 8) {
    const tableRows = [ 
        { label: "Scheme Name", value: selectedPlot.gisSchemeName },
        { label: "Survey  Date", value: selectedPlot.applicationDate 
                ? new Date(selectedPlot.applicationDate).toLocaleDateString("en-CA") 
                : "" 
            },
        { label: "Survey No", value: selectedPlot.surveyNo },
        { label: "Farmer Name", value: selectedPlot.farmerName },
        { label: "Status", value: selectedPlot.status },
        { label: "Crop Group Name", value: selectedPlot.cropGroupName },
        { label: "State", value: selectedPlot.stateName },
        { label: "District", value: selectedPlot.districtName },
        { label: "Village", value: selectedPlot.subDistrictName },
        { label: "Address", value: selectedPlot.address },
        { label: "Crop Name", value: selectedPlot.cropName },
       
        { label: "Sowing Date", value: selectedPlot.sowingDate 
                ? new Date(selectedPlot.sowingDate).toLocaleDateString("en-CA") 
                : "" 
            },
        { label: "Season Name", value: selectedPlot.seasonName },
        { label: "Area Under Demonstration ", value: selectedPlot.areaUnderDemonstration },
        { label: "Demonstration Yield", value: selectedPlot.demonstrationYield },
        { label: "Avg Yield of Village ", value: selectedPlot.avgYieldofVillage },
       
        { label: "Area", value: selectedPlot.area },
        { label: "Component", value: selectedPlot.component },
        { label: "Constitution", value: selectedPlot.constitution },
        { label: "Crop Item", value: selectedPlot.crop_Item },
    ];

    const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Separate images and videos
    const imageUrls = selectedPlot.photosAndVideos.filter(media => 
        !media.source.endsWith(".mp4") // Filter out videos
    ).map(media => media.source);

    const videoUrls = selectedPlot.photosAndVideos.filter(media => 
        media.source.endsWith(".mp4") // Only videos
    ).map(media => media.source);

    // Default image if none found
    if (imageUrls.length === 0) {
        imageUrls.push("https://krishimapper.dac.gov.in/imagenotfound.png");
    }

    // First image for table display
    const firstImageUrl = imageUrls[0];

    // Display first image in the details table
    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px"
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    // Construct content string for display
    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for images
    const imageCarouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="Image">
        </div>`).join("");

    // Generate carousel items for videos
    const videoCarouselItems = videoUrls.map((video, index) => `
        <div class="carousel-item">
            <video class="d-block w-100" controls>
                <source src="${video}" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>`).join("");

    // Combine images and videos in the carousel
    document.getElementById("imageCarouselInner").innerHTML = imageCarouselItems + videoCarouselItems;
    }

    if (selected[0].value === '9') {
        const tableRows = [ 
            { label: "Scheme Name", value: selected[0].label },
            
            { label: "Crop Group Name", value: selectedPlot.cropGroupName },
            { label: "Crop Name", value: selectedPlot.cropName },
           
            { label: "Season Name", value: selectedPlot.seasonName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode ===10) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Survey Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
           
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "Survey No ", value: selectedPlot.surveyNo },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Land Area", value: selectedPlot.landArea },
            { label: "Activity Type", value: selectedPlot.activityType },
            { label: "Block Name", value: selectedPlot.blockName },
            
            { label: "Crop Group Name", value: selectedPlot.cropGroupName },
            { label: "Crop Name", value: selectedPlot.cropName },
            
            { label: "Season Name", value: selectedPlot.seasonName },
           
        ];

         const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
     if (selectedPlot.gisSchemeCode ===11) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
           
            { label: "Survey No", value: selectedPlot.surveyNo },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Land Area", value: selectedPlot.landArea },
            { label: "Block Name", value: selectedPlot.blockName },
            
            { label: "Crop Group Name", value: selectedPlot.cropGroupName },
            { label: "Crop Name", value: selectedPlot.cropName },
            
            { label: "Season Name", value: selectedPlot.seasonName },
        ];

        const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

        // Extract image URLs from `farmerCropSurveyImageList` array
        const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
            ? selectedPlot.farmerCropSurveyImageList.map(img => 
                `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
              )
            : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

        // Show the first image in table
        const firstImageUrl = imageUrls[0];

        const imageRow = `
            <tr>
                <th>Image :</th>
                <td>
                    <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                         data-bs-toggle="modal" data-bs-target="#imageModal">
                </td>
            </tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>`;

        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

        // Generate carousel items for multiple images
        const carouselItems = imageUrls.map((img, index) => `
            <div class="carousel-item ${index === 0 ? "active" : ""}">
                <img src="${img}" class="d-block w-100" alt="...">
            </div>`).join("");

        document.getElementById("imageCarouselInner").innerHTML = carouselItems;    }
    if (selected[0].value === '30') {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.schemeName },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Land Area", value: selectedPlot.landArea },
            { label: "Block Name", value: selectedPlot.blockName },
            { label: "Crop Group Name", value: selectedPlot.cropGroupName },
            { label: "Crop Name", value: selectedPlot.cropName },
            { label: "Season Name", value: selectedPlot.seasonName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode ===12) {
        const tableRows = [ 
            { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.createdate 
                ? new Date(selectedPlot.createdate).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Surveyer Name ", value: selectedPlot.username },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
          
            { label: "Test center created At ", value: selectedPlot.testcenter_createdAt 
                ? new Date(selectedPlot.testcenter_createdAt).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Test Center District Name ", value: selectedPlot.testCenterDistrictName },
            { label: "Status", value: selectedPlot.status },
            { label: "Lab Type", value: selectedPlot.labType },
            { label: "Test Center Name", value: selectedPlot.testCenterName },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Farmer Address", value: selectedPlot.farmerAddress },
        
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode ===13) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName},
             { label: "Surveyer Name ", value: selectedPlot.username },
            { label: "Survey  Date", value: selectedPlot.plotImage[0].createdAt 
                ? new Date(selectedPlot.plotImage[0].createdAt ).toLocaleDateString("en-CA") 
                : "" 
            },
          { label: "Survey No", value: selectedPlot.surveyNo},
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Address", value: selectedPlot.farmerAddress },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "farmer Address", value: selectedPlot.farmerAddress },
            { label: "Status", value: selectedPlot.status },
            { label: "Soil Color", value: selectedPlot.soilColor },
            { label: "Soil Density", value: selectedPlot.soilDensity },
            { label: "Soil status", value: selectedPlot.soilStatus },
            { label: "Soil testure", value: selectedPlot.soilTexture },
            
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

       const imageUrls = selectedPlot.plotImage.length > 0
        ? selectedPlot.plotImage.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/Images/GetSHCImages/${selectedPlot.stateCode}/${selectedPlot.districtCode}/${img.image}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;

    }
    if (selectedPlot.gisSchemeCode ===14) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "Address", value: selectedPlot.farmerAddress },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Status", value: selectedPlot.status },
            { label: "Lab Type", value: selectedPlot.labType },
            
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selected[0].value === '15') {
        const tableRows = [ 
          { label: "Scheme Name", value: selected[0].label },
             { label: "Survey  Date", value: selectedPlot.date_time 
                ? new Date(selectedPlot.date_time).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.village },
            { label: "Address", value: selectedPlot.farmerAddress },
            { label: "Observer Name", value: selectedPlot.observername },
            { label: "Status", value: selectedPlot.status },
            { label: "Mandal", value: selectedPlot.mandal },
            { label: "Beneficiary  Name", value: selectedPlot.benf_name },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
            { label: "Quantity", value: selectedPlot.quantity },
            { label: "Project Status", value: selectedPlot.projectstatus },
            { label: "Project Starting Year", value: selectedPlot.projectstartingyear },
            { label: "Year Completion", value: selectedPlot.yearcompletion },
            { label: "Project Cost SLSC", value: selectedPlot.projectCostSLSC },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot.photo1 || "https://krishimapper.dac.gov.in/imagenotfound.png";
        const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;

        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode ===16) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveryPolygon[0].userName },
             { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "farmer Address", value: selectedPlot.farmerAddress },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Status", value: selectedPlot.status },
            { label: "Land Area", value: selectedPlot.landArea },
           
            { 
                label: "Total Area", 
                value: selectedPlot.totalArea 
                    ? parseFloat(selectedPlot.totalArea).toFixed(2) 
                    : "0.00" 
                },
            { label: "Test Center Name", value: selectedPlot.testCenterName },
            { label: "Survey No ", value: selectedPlot.surveyNo },
           
           
        ];

        const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImage.length > 0
        ? selectedPlot.farmerCropSurveyImage.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode === 17) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
            { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Component Name", value: selectedPlot.componentName },
            { label: "Status", value: selectedPlot.status },
            { label: "Land Area", value: selectedPlot.landArea },
            { label: "Crop Life Cycle Name", value: selectedPlot.cropLifeCycleName },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
            { label: "farmer Address", value: selectedPlot.farmerAddress },
            { label: "Survey No", value: selectedPlot.surveyNo },

           
        ];

        const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode ===18) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey No", value: selectedPlot.surveyNo },
         { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
          { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
           
             { 
                label: "Total Area", 
                value: selectedPlot.totalArea 
                    ? parseFloat(selectedPlot.totalArea).toFixed(2) 
                    : "0.00" 
                },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Address", value: selectedPlot.farmerAddress },
            { label: "Status", value: selectedPlot.status },
            { label: "Lab Type", value: selectedPlot.labType },
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

       const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode ===19) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.date 
                ? new Date(selectedPlot.date).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.state },
            { label: "Sub District", value: selectedPlot.subDistrict },
            { label: "Village", value: selectedPlot.village },
          { label: "Crop Name", value: selectedPlot.crop },
          { label: "Pest Name", value: selectedPlot.pest },
          { label: "Pest Type", value: selectedPlot.pestType },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Farmer Address", value: selectedPlot.farmerAddress },
            { label: "Status", value: selectedPlot.status },
            { label: "Lab Type", value: selectedPlot.labType },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selectedPlot.gisSchemeCode ===20) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
          { label: "Survey  Date", value: selectedPlot.date 
                ? new Date(selectedPlot.date).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "Block", value: selectedPlot.blockName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "farmer Name", value: selectedPlot.farmer_name },
            { label: "Farmer Address", value: selectedPlot.farmer_address },
            { label: "Tech Name", value: selectedPlot.tech_name },
            { label: "Status", value: selectedPlot.status },
           
            
             { 
                label: "Total Area", 
                value: selectedPlot.total_land_area 
                    ? parseFloat(selectedPlot.total_land_area).toFixed(2) 
                    : "0.00" 
                },
            { label: "land Area Cotton", value: selectedPlot.land_area_cotton },
            { label: "Lab Type", value: selectedPlot.labType },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

               const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        const imageUrl = selectedPlot.land_photo || "https://krishimapper.dac.gov.in/imagenotfound.png";
        const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}${imageRow}</table>
            </div>`;

        const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;

        document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }
    if (selected[0].value === "29") {
        

        if(selectedPlot.schemeName === "National Mission on Edible Oils (NMEO)-OP"){
           // alert(selectedPlot.schemeName)
        const tableRows = [ 
          { label: "Scheme Name", value: "NMEO-OP" },
          { label: "Company Name", value: selectedPlot.schemeName },
          { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Survey User Code", value: selectedPlot.surveyUserCode },
            { label: "State", value: selectedPlot.stateName },
            { label: "Block", value: selectedPlot.blockName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "Agency Name", value: selectedPlot.agencyName },
            { label: "User Name", value: selectedPlot.userName },
            { label: "Farmer Name", value: selectedPlot.farmerName },
            { label: "Farmer Address", value: selectedPlot.farmer_address },
            { label: "Tech Name", value: selectedPlot.tech_name },
            { label: "Status", value: selectedPlot.status },
            { 
                label: "Total Area", 
                value: selectedPlot.farmerPlotRegistrationList[0].plotTotalArea 
                    ? parseFloat(selectedPlot.farmerPlotRegistrationList[0].plotTotalArea).toFixed(2) 
                    : "0.00" 
            },
            { 
                label: "Area Cultivation", 
                value: selectedPlot.farmerPlotRegistrationList[0].plotatAreaCultivation 
                    ? parseFloat(selectedPlot.farmerPlotRegistrationList[0].plotatAreaCultivation).toFixed(2) 
                    : "0.00" 
            },{ 
                label: "Num of Oil Palm Trees", 
                value: selectedPlot.farmerPlotRegistrationList[0].numofoilpalmtrees 
                    ? parseFloat(selectedPlot.farmerPlotRegistrationList[0].numofoilpalmtrees).toFixed(2) 
                    : "0.00" 
            },{ 
                label: "Plant Month Year", 
                value: selectedPlot.farmerPlotRegistrationList[0].plantMonthYear 
                    ? parseFloat(selectedPlot.farmerPlotRegistrationList[0].plantMonthYear).toFixed(2) 
                    : "0.00" 
            },{ 
                label: "fbb Production", 
                value: selectedPlot.farmerPlotRegistrationList[0].fbbProduction 
                    ? parseFloat(selectedPlot.farmerPlotRegistrationList[0].fbbProduction).toFixed(2) 
                    : "0.00" 
            },
            { label: "land Area Cotton", value: selectedPlot.land_area_cotton },
            { label: "Lab Type", value: selectedPlot.labType },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

               const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

         const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }else{
        
        function getDetailValue(description, key) {
        if (key.includes("Month and Year")) {
            const regex = new RegExp(`${key} - (\\d{2}/\\d{4})`); // Capture MM/YYYY format
            const match = description.match(regex);
            return match ? match[1].trim() : "N/A";
        } else {
            const regex = new RegExp(`${key} - ([^A-Z]+)`, "i"); // Extracts value until next uppercase letter (key separator)
            const match = description.match(regex);
            return match ? match[1].split("/")[0].trim() : "N/A"; // Handle cases with extra '/'
        }
    }

    function getFarmerName(value) {
        const match = value.match(/Farmer ID\/Name - (\d+) \/ (.+)/);
        return match ? `${match[2]} (${match[1]})` : value;
    }

    // Extract State Name Properly
    function getStateValue(description) {
        const match = description.match(/State Name\/Code - ([^\/\n]+)/);
        return match ? match[1].trim() : "N/A";
    }

    // Extract District, Block, and Village Correctly
    function extractLocation(description, key) {
        const regex = new RegExp(`${key}\\s*-\\s*([^/\\n]+)`, "i");
        const match = description.match(regex);
        return match ? match[1].trim() : "N/A";
    }

    const tableRows = [
        { label: "Scheme", value: 'NMEO-OP' },
        { label: "Company Name", value: 'Patanjali' },
        { label: "Farmer Name", value: getFarmerName(selectedPlot?.name || "N/A") },
        { label: "State", value: getStateValue(selectedPlot.description) || "N/A" },
        { label: "District", value: extractLocation(selectedPlot.description, "District Name/Code") || "N/A" },
        { label: "Tehsil/Block", value: extractLocation(selectedPlot.description, "Tehsil /Block Name/Code") || "N/A" },
        { label: "Village", value: extractLocation(selectedPlot.description, "Village") || "N/A" },
        { label: "Total Area of the Plot", value: getDetailValue(selectedPlot.description, "Total Area of the Plot") || "N/A" },
        { label: "Total Area of the Plot under Oil Palm Cultivation", value: getDetailValue(selectedPlot.description, "Total Area of the Plot under Oil Palm Cultivation") || "N/A" },
        { label: "Land Registration ID /Survey Number", value: getDetailValue(selectedPlot.description, "Land Registration ID /Survey Number") || "N/A" },
        { label: "Ownership holding", value: getDetailValue(selectedPlot.description, "Ownership holding (Land holding)") || "N/A" },
        { label: "Geo tagging reference details", value: getDetailValue(selectedPlot.description, "Geo tagging reference details") || "N/A" },
        { label: "Number of Plants in the Plot", value: getDetailValue(selectedPlot.description, "Number of Plants in the Plot") || "N/A" },
        { label: "Month and Year of Sowing/Plantation", value: getDetailValue(selectedPlot.description, "Month and Year of Sowing/Plantation") || "N/A" },
        { label: "Month and Year to Start of FFB Production", value: getDetailValue(selectedPlot.description, "Month and Year to Start of FFB Production") || "N/A" },
        { label: "Name of the FFBs Procurement Agency", value: getDetailValue(selectedPlot.description, "Name of the FFBs Procurement Agency") || "N/A" }
    ];

    const rowsHtml = tableRows
        .filter(row => row.value && row.value !== "N/A") // Remove empty rows
        .map(row => `<tr><th>${row.label} :</th><td>${row.value}</td></tr>`)
        .join("");

    // Content without image
    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}</table>
        </div>`;

    // Debugging output
    console.log("Generated HTML:", contentStringCotton);

    // Ensure the element exists before modifying
    const infoContainer = document.getElementById("infoDetailsCotton");
    if (infoContainer) {
        infoContainer.style.display = "block";
        infoContainer.innerHTML = contentStringCotton;
    } else {
        console.error("Error: Element with id 'infoDetailsCotton' not found!");
    }
    }
    }


    if (selectedPlot.gisSchemeCode === 31) {
  const tableRows = [
    { label: "Scheme Name", value: selectedPlot.schemeName },
    {
      label: "Survey Date",
      value: selectedPlot.createdOn
        ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA")
        : "N/A",
    },
    { label: "Survey User Code", value: selectedPlot.surveyUserCode || "N/A" },
    { label: "State", value: selectedPlot.stateName },
    { label: "District", value: selectedPlot.districtName },
    { label: "Sub-District", value: selectedPlot.subDistrictName },
    { label: "Block", value: selectedPlot.blockName },
    { label: "Village", value: selectedPlot.villageName },
    { label: "Agency Name", value: selectedPlot.agencyName || "N/A" },
    { label: "User Name", value: selectedPlot.userName || "N/A" },
    { label: "Farmer Name", value: selectedPlot.farmerName },
    { label: "Farmer Address", value: selectedPlot.farmer_address || "N/A" },
    { label: "Tech Name", value: selectedPlot.tech_name || "N/A" },
    { label: "Status", value: selectedPlot.status || "N/A" },
    {
      label: "Crop Stage Name",
      value: selectedPlot.farmerCropStageList?.[0]?.cropStageName || "N/A",
    },
    { label: "Land Area Cotton", value: selectedPlot.land_area_cotton || "N/A" },
    { label: "Lab Type", value: selectedPlot.labType || "N/A" },
    { label: "Test Center Name", value: selectedPlot.testCenterName || "N/A" },
  ];

  const rowsHtml = tableRows
    .filter(row => row.value && row.value !== "N/A")
    .map(row => `<tr><th>${row.label}:</th><td>${row.value}</td></tr>`)
    .join("");

  const aadhaarImages = selectedPlot.farmerAadhaarImageList?.map(img => img.attPath) || [];
  const seedImages = selectedPlot.farmerSeedDistributionImageList?.map(img => img.attPath) || [];
  const surveyImages = selectedPlot.farmerCropSurveyImageList?.map(img => img.attPath) || [];

  const allImages = [
    ...aadhaarImages.map((url, i) => ({ url, type: "Aadhaar Image", index: i })),
    ...seedImages.map((url, i) => ({ url, type: "Seed Distribution Image", index: i })),
    ...surveyImages.map((url, i) => ({ url, type: "Crop Survey Image", index: i })),
  ];

  const mainImage = aadhaarImages[0] || seedImages[0] || surveyImages[0] || "https://krishimapper.dac.gov.in/imagenotfound.png";

  const aadhaarRow = aadhaarImages.length
    ? `<tr><th>Aadhaar Image:</th><td><img src="${aadhaarImages[0]}" height="150" width="150" style="cursor:pointer" data-bs-toggle="modal" data-bs-target="#imageModal"/></td></tr>`
    : "";

  const seedRow = seedImages.length
    ? `<tr><th>Seed Distribution Image:</th><td><img src="${seedImages[0]}" height="150" width="150" style="cursor:pointer" data-bs-toggle="modal" data-bs-target="#imageModal"/></td></tr>`
    : "";

  const surveyRow = surveyImages.length
    ? `<tr><th>Survey Image:</th><td><img src="${surveyImages[0]}" height="150" width="150" style="cursor:pointer" data-bs-toggle="modal" data-bs-target="#imageModal"/></td></tr>`
    : "";

  const contentString = `
    <div class="table-responsive imgthumbnails">
      <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
      <table class="table table-bordered table-sm">
        ${rowsHtml}${aadhaarRow}${seedRow}${surveyRow}
      </table>
    </div>`;

  document.getElementById("infoDetailsCotton").style.display = "block";
  document.getElementById("infoDetailsCotton").innerHTML = contentString;

  // Carousel content
  const carouselItems = allImages.map((img, index) => `
    <div class="carousel-item ${index === 0 ? "active" : ""}">
      <div class="text-center">
        <p><strong>${img.type} ${img.index + 1}</strong></p>
        <img src="${img.url}" class="d-block w-100" alt="${img.type} ${img.index + 1}">
      </div>
    </div>`).join("");

  document.getElementById("imageCarouselInner").innerHTML = carouselItems;
}



     if (selectedPlot.gisSchemeCode ===30) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.schemeName },
          { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Survey Number ", value: selectedPlot.surveyNumber },
            { label: "Survey  Code", value: selectedPlot.surveyorCode },
            { label: "Survey User Code", value: selectedPlot.surveyUserCode },
            { label: "State", value: selectedPlot.stateName },
            { label: "Block", value: selectedPlot.blockName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "Agency Name", value: selectedPlot.agencyName },
            { label: "User Name", value: selectedPlot.userName },
            { label: "Sector Name", value: selectedPlot.sectorName },
            { label: "Sub Sector Name", value: selectedPlot.subSectorName },
            { label: "Project Status ", value: selectedPlot.projectStatus },
            { label: "Project Name ", value: selectedPlot.projectName },
            { label: "Project Cost ", value: selectedPlot.projectCost },
            { label: "Farmer Name", value: selectedPlot.farmerName },
            { label: "Number of Beneficiary", value: selectedPlot.numberofBeneficiary },
            { label: "Farmer Address", value: selectedPlot.farmer_address },
            { label: "Tech Name", value: selectedPlot.tech_name },
            { label: "Status", value: selectedPlot.status },
            { label: "Project Approval Date", value: selectedPlot.projectApprovalDate },
            { label: "Project Starting Date", value: selectedPlot.projectStartingDate },
            { label: "Expenditure Report Date", value: selectedPlot.expenditureReportDate },
            { label: "Status", value: selectedPlot.status },
           
            
             { 
                label: "Total Area", 
                value: selectedPlot.total_land_area 
                    ? parseFloat(selectedPlot.total_land_area).toFixed(2) 
                    : "0.00" 
                },
            { label: "land Area Cotton", value: selectedPlot.land_area_cotton },
            { label: "Lab Type", value: selectedPlot.labType },
            
           
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

               const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

         const imageUrls = selectedPlot.projectRKVYImageLists.length > 0
        ? selectedPlot.projectRKVYImageLists.map(img => 
            `${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selected[0].value === "21") {
        const tableRows = [ 
            { label: "Fin. Year", value: selectedPlot.session_Year },
          { label: "Scheme Name", value: "Seed Hub" },
            { label: "Season", value: selectedPlot.season },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.villageName },
            { label: "Block", value: selectedPlot.blockName },
            { label: "Crop Name", value: selectedPlot.cropName },
            { label: "Crop Block", value: selectedPlot.cropBlock },
            { label: "Crop District", value: selectedPlot.cropDistrict },
            { label: "Crop Village", value: selectedPlot.cropVillage },
            { label: "Source Class", value: selectedPlot.sourceClass },
            { label: "Destination Class", value: selectedPlot.destinationClass },
            { label: "Grower Name", value: selectedPlot.growerName },
            { label: "Grower Block", value: selectedPlot.growerBlock },
            { label: "Grower District", value: selectedPlot.growerDistrict },
            { label: "Grower Village", value: selectedPlot.growerVillage },
            { label: "Certified Area(ha)", value: selectedPlot.certifiedArea },
            { label: "Inspection Area(ha)", value: selectedPlot.inspectionArea },
            { label: "Registered Area(hq)", value: selectedPlot.registeredArea },
            
           
          
           
        ];

        const rowsHtml = tableRows
            .filter(row => row.value)
            .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
            .join("");

        //const imageUrl = selectedPlot.geoImages || "https://krishimapper.dac.gov.in/imagenotfound.png";
        //const imageRow = `<tr><th>Image :</th><td><img alt="image" src="${imageUrl}" data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></td></tr>`;

        const contentStringCotton = `
            <div class="table-responsive imgthumbnails">
                <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
                <table class="table">${rowsHtml}</table>
            </div>`;

       /* const filteredImageHtml = `
            <div class="carousel-item active">
                <img src="${imageUrl}" class="d-block w-100" alt="..."/>
            </div>`;*/

        //document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
        document.getElementById("infoDetailsCotton").style.display = "block";
        document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;
    }if (selectedPlot.gisSchemeCode ===22) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
          { label: "Beneficiary Name", value: selectedPlot.beneficiaryName },
          { label: "Beneficiary Type Name", value: selectedPlot.beneficiaryTypeName },
          { label: "Beneficiary Registraion No", value: selectedPlot.beneficiary_Reg_No },
          { label: "Component Name ", value: selectedPlot.componentName },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: "Farmenr Address", value: selectedPlot.farmerAddress },
            { label: "Status", value: selectedPlot.status },
            { label: "land Type", value: selectedPlot.landType },
            { label: "Lab Type", value: selectedPlot.labType },
            
            { label: "Survey No ", value: selectedPlot.surveyNo },
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
           
        ];

        const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    // Extract image URLs from `farmerCropSurveyImageList` array
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

    // Show the first image in table
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }
    if (selectedPlot.gisSchemeCode === 23) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
           { label: "Survey  Date", value: selectedPlot.createdOn 
                ? new Date(selectedPlot.createdOn).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "Village", value: selectedPlot.subDistrictName },
            { label: "Status", value: selectedPlot.status },
            { label: "Lab Type", value: selectedPlot.labType },
            { label: "Category Name", value: selectedPlot.categoryName },
            { label: "farmer Name", value: selectedPlot.farmerName },
            { label: " Farmer Address", value: selectedPlot.farmerAddress },
            { label: "Center Name", value: selectedPlot.centerName },
            { label: "Component Name", value: selectedPlot.componentName },
            { label: "Crop Life Cycle Name", value: selectedPlot.cropLifeCycleName },
           
             { 
                label: "Total Area", 
                value: selectedPlot.totalArea 
                    ? parseFloat(selectedPlot.totalArea).toFixed(2) 
                    : "0.00" 
                },
            
            { label: "Survey No ", value: selectedPlot.surveyNo },
            { label: "Surveyer Name ", value: selectedPlot.farmerCropSurveyPolygonList[0].userName },
          
            { label: "Test Center Name", value: selectedPlot.testCenterName },
           
        ];

         const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    
    const imageUrls = selectedPlot.farmerCropSurveyImageList.length > 0
        ? selectedPlot.farmerCropSurveyImageList.map(img => 
            `https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${img.attPath}`
          )
        : ["https://krishimapper.dac.gov.in/imagenotfound.png"];

   
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        <tr>
            <th>Image :</th>
            <td>
                <img alt="image" src="${firstImageUrl}" height="150px" width="150px" 
                     data-bs-toggle="modal" data-bs-target="#imageModal">
            </td>
        </tr>`;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }     

       if (selectedPlot.gisSchemeCode === 26) {
        const tableRows = [ 
          { label: "Scheme Name", value: selectedPlot.gisSchemeName },
            { label: "State", value: selectedPlot.stateName },
            { label: "District", value: selectedPlot.districtName },
            { label: "sub District Name", value: selectedPlot.subDistrictName },
            { label: "Village Name", value: selectedPlot.villageName },
            { label: "Croping Type Name", value: selectedPlot.cropingTypeName },
            { label: "Crop Stage Name", value: selectedPlot.cropStageName },
            { label: "Crop Condition Name", value: selectedPlot.cropConditionName },
            { label: "Crop Name", value: selectedPlot.cropName },
            { label: "Crop Category Name", value: selectedPlot.cropCategoryName },
            { label: " Plot Area", value: selectedPlot.plotArea },
           
            { label: "Showing  Date", value: selectedPlot.showingDate 
                ? new Date(selectedPlot.showingDate).toLocaleDateString("en-CA") 
                : "" 
            },
            { label: "Survey Code ", value: selectedPlot.surveyCode },
            { label: "Surveyor Name ", value: selectedPlot.surveyorName },
            { label: "Season Name", value: selectedPlot.seasonName },
            { label: "Company Name", value: selectedPlot.company_name },
           
           
           
        ];

         const rowsHtml = tableRows
        .filter(row => row.value)
        .map(row => `<tr><th>${row.label} : &nbsp</th><td>${row.value}</td></tr>`)
        .join("");

    
    const imageUrls = "https://krishimapper.dac.gov.in/imagenotfound.png";

   
    const firstImageUrl = imageUrls[0];

    const imageRow = `
        `;

    const contentStringCotton = `
        <div class="table-responsive imgthumbnails">
            <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
            <table class="table">${rowsHtml}${imageRow}</table>
        </div>`;

    document.getElementById("infoDetailsCotton").style.display = "block";
    document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton;

    // Generate carousel items for multiple images
    const carouselItems = imageUrls.map((img, index) => `
        <div class="carousel-item ${index === 0 ? "active" : ""}">
            <img src="${img}" class="d-block w-100" alt="...">
        </div>`).join("");

    document.getElementById("imageCarouselInner").innerHTML = carouselItems;
    }     
    
};
